import { createFileRoute } from '@tanstack/react-router';
import { OriginationPage } from '@/domains/credit';

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/origination')({
    component: CreditOrigination,
});

function CreditOrigination() {
    return <OriginationPage />;
}
